import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57a59cc7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "top-bar-box query-none"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "status",
  style: {
    "background": "#5ab46b"
  }
}, "已验收", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "status",
  style: {
    "background": "#b45a5a"
  }
}, "报修中", -1));
const _hoisted_6 = {
  class: "table-box"
};
const _hoisted_7 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 1,
  style: {
    "color": "#f8f8f8",
    "cursor": "not-allowed",
    "font-weight": "400"
  }
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_12 = {
  style: {
    "margin-right": "5px"
  }
};
const _hoisted_13 = {
  style: {
    "width": "300px",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_14 = {
  class: "appointment-info-item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "22px"
  }
}, "预约信息", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-point"
}), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "16px",
    "color": "#305aff"
  }
}, "对接人：")], -1));
const _hoisted_17 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0px 10px"
  }
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "4px",
    "height": "4px",
    "margin-right": "15px"
  }
}, null, -1));
const _hoisted_19 = {
  style: {
    "font-size": "16px"
  }
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-point"
}), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "16px",
    "color": "#305aff"
  }
}, "对接人电话：")], -1));
const _hoisted_21 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0px 10px"
  }
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "4px",
    "height": "4px",
    "margin-right": "15px"
  }
}, null, -1));
const _hoisted_23 = {
  style: {
    "font-size": "16px"
  }
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-point"
}), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "16px",
    "color": "#305aff"
  }
}, "维修人：")], -1));
const _hoisted_25 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0px 10px"
  }
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "4px",
    "height": "4px",
    "margin-right": "15px"
  }
}, null, -1));
const _hoisted_27 = {
  style: {
    "font-size": "16px"
  }
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-point"
}), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "16px",
    "color": "#305aff"
  }
}, "维修人电话：")], -1));
const _hoisted_29 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0px 10px"
  }
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "4px",
    "height": "4px",
    "margin-right": "15px"
  }
}, null, -1));
const _hoisted_31 = {
  style: {
    "font-size": "16px"
  }
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "appointment-info-point"
}), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "16px",
    "color": "#305aff"
  }
}, "维修日期：")], -1));
const _hoisted_33 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0px 10px"
  }
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "4px",
    "height": "4px",
    "margin-right": "15px"
  }
}, null, -1));
const _hoisted_35 = {
  style: {
    "font-size": "16px"
  }
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 1,
  style: {
    "color": "#f8f8f8",
    "cursor": "not-allowed",
    "font-weight": "400"
  }
};
const _hoisted_38 = {
  style: {
    "margin-left": "8px"
  }
};
const _hoisted_39 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "指派维修", -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消维修", -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预约", -1));
const _hoisted_43 = {
  class: "bottom-pagination-box"
};
const _hoisted_44 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "box-sizing": "border-box"
  }
};
const _hoisted_45 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_46 = {
  class: "QRcodeBox",
  ref: "QRcodeBox"
};
const _hoisted_47 = {
  class: "top"
};
const _hoisted_48 = {
  class: "top"
};
const _hoisted_49 = {
  style: {
    "text-align": "center",
    "margin": "30px 0"
  }
};
const _hoisted_50 = ["src"];
const _hoisted_51 = {
  class: "bottom"
};
const _hoisted_52 = {
  class: "bottom"
};
const _hoisted_53 = {
  class: "QRtitle"
};
const _hoisted_54 = {
  class: "copyQR"
};
const _hoisted_55 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_56 = {
  class: "photosViewBox"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_59 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "100px"
  }
}, "报修指派", -1));
const _hoisted_61 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_date_picker = _resolveComponent("a-date-picker");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_a_popover = _resolveComponent("a-popover");
  const _component_a_button = _resolveComponent("a-button");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_vxe_pager = _resolveComponent("vxe-pager");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_modal = _resolveComponent("a-modal");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_a_tree_select = _resolveComponent("a-tree-select");
  const _component_a_auto_complete = _resolveComponent("a-auto-complete");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_select, {
    value: _ctx.storeNameSelect,
    "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.storeNameSelect = $event),
    class: "query-field",
    filterable: "",
    allowClear: "",
    "show-search": "",
    placeholder: "选择店铺",
    size: "medium",
    style: {
      "width": "150px"
    },
    onChange: _ctx.queryRepair
  }, {
    suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
      class: "ant-select-suffix",
      style: {
        "color": "#818181"
      }
    })]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeData, item => {
      return _openBlock(), _createBlock(_component_a_select_option, {
        value: item.value,
        key: item.value
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
        _: 2
      }, 1032, ["value"]);
    }), 128))]),
    _: 1
  }, 8, ["value", "onChange"]), _createVNode(_component_a_select, {
    class: "query-field",
    filterable: "",
    allowClear: "",
    value: _ctx.vendorNameSelect,
    "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.vendorNameSelect = $event),
    placeholder: "选择供应商",
    size: "medium",
    onChange: _ctx.queryRepair,
    style: {
      "width": "150px"
    }
  }, {
    suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
      class: "ant-select-suffix",
      style: {
        "color": "#818181"
      }
    })]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendorData, item => {
      return _openBlock(), _createBlock(_component_a_select_option, {
        key: item.vendorId,
        value: item.vendorName
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
        _: 2
      }, 1032, ["value"]);
    }), 128))]),
    _: 1
  }, 8, ["value", "onChange"]), _createVNode(_component_a_date_picker, {
    editable: false,
    class: "light-gray-date-picker query-field",
    style: {
      "width": "150px"
    },
    value: _ctx.repairStar,
    "onUpdate:value": _cache[2] || (_cache[2] = $event => _ctx.repairStar = $event),
    placeholder: "开始时间",
    format: "YYYY-MM-DD",
    "value-format": "YYYY-MM-DD 00:00:00",
    onChange: _ctx.queryRepair
  }, null, 8, ["value", "onChange"]), _createVNode(_component_a_date_picker, {
    editable: false,
    class: "light-gray-date-picker query-field",
    style: {
      "width": "150px"
    },
    value: _ctx.repairEnd,
    "onUpdate:value": _cache[3] || (_cache[3] = $event => _ctx.repairEnd = $event),
    placeholder: "结束时间",
    format: "YYYY-MM-DD",
    "value-format": "YYYY-MM-DD 00:00:00",
    onChange: _ctx.queryRepair
  }, null, 8, ["value", "onChange"]), _hoisted_4, _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_vxe_table, {
    border: false,
    stripe: "",
    size: "small",
    class: "column-sort",
    ref: "xTable",
    height: "auto",
    "row-config": {
      isCurrent: true,
      isHover: true
    },
    data: _ctx.repairData,
    "sort-config": {
      showIcon: false
    },
    onHeaderCellClick: _ctx.headerCellClickEvent,
    onScroll: _ctx.userTableScroll,
    "row-class-name": _ctx.rowClassName
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "storeName",
      width: "300",
      title: "店铺名称",
      "show-overflow": "",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", _hoisted_7, _toDisplayString(row.storeName), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "storeCode",
      width: "200",
      title: "CLC Code",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "city",
      width: "100",
      title: "城市",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "storeFloor",
      width: "100",
      title: "报修楼层",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "locationDescription",
      "min-width": "250",
      title: "报修点位",
      "show-overflow": "",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "badPhoto",
      width: "100",
      title: "损坏照片"
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [row.badPhoto && row.badPhoto.length > 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: $event => _ctx.openPhotos(row.badPhoto),
        style: {
          "color": "#0763db",
          "cursor": "pointer",
          "font-weight": "400"
        }
      }, " 查看 ", 8, _hoisted_8)) : (_openBlock(), _createElementBlock("span", _hoisted_9, " 查看 "))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "reporterTime",
      width: "200",
      title: "报修时间",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", null, _toDisplayString(_ctx.getDate(row.reporterTime)), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "repairResultNameZh",
      width: "120",
      title: "状态",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      default: _withCtx(({
        row,
        rowIndex
      }) => [row.repairResultId === 1 || row.repairResultId === 7 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(row.repairResultNameZh), 1)) : _createCommentVNode("", true), row.repairResultId > 1 && row.repairResultId < 7 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(row.repairResultNameZh), 1), _createVNode(_component_a_popover, {
        overlayClassName: `popover-${rowIndex} appointment-info-box`,
        "v-model:open": row.popoverVisible,
        arrowPointAtCenter: false,
        placement: "bottom",
        trigger: "click"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_svg_icon, {
          style: {
            "margin-left": "auto"
          },
          iconName: "copy",
          iconSize: "20px",
          onClick: $event => _ctx.copyInfo(row)
        }, null, 8, ["onClick"])]), _createVNode(_component_a_divider), _hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(row.storeStaffName), 1)]), _hoisted_20, _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(row.storeStaffMobile), 1)]), _hoisted_24, _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("span", _hoisted_27, _toDisplayString(row.repairerName), 1)]), _hoisted_28, _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString(row.repairerMobile), 1)]), _hoisted_32, _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getDate(row.repairTime)), 1)])])]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          style: {
            "outline": "none",
            "margin-right": "10px"
          },
          onClick: $event => _ctx.showAppointmentInfo(`popover-${rowIndex}`, row, rowIndex),
          iconName: "Tips",
          iconSize: "16px"
        }, null, 8, ["onClick"])]),
        _: 2
      }, 1032, ["overlayClassName", "v-model:open"])])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "fixPhoto",
      width: "100",
      title: "修复照片",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      default: _withCtx(({
        row
      }) => [row.badPhoto && row.badPhoto.length > 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: $event => _ctx.openPhotos(row.fixPhoto),
        style: {
          "color": "#0763db",
          "cursor": "pointer",
          "font-weight": "400"
        }
      }, " 查看 ", 8, _hoisted_36)) : (_openBlock(), _createElementBlock("span", _hoisted_37, " 查看 "))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "vendorName",
      width: "100",
      title: "供应商",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title) + _toDisplayString(console.log(column.order)), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "repairerLeadName",
      width: "120",
      title: "维修负责人",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title) + _toDisplayString(console.log(column.order)), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "repairerLeadMobile",
      width: "120",
      title: "负责人手机",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title) + _toDisplayString(console.log(column.order)), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "repairerLeadEmail",
      width: "200",
      title: "负责人邮箱",
      "show-overflow": "",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title) + _toDisplayString(console.log(column.order)), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "sortup",
        iconSize: "24px"
      })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        iconName: "sortdown",
        iconSize: "24px"
      })) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 2,
        iconName: "sort2",
        iconSize: "24px"
      }))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      width: "100",
      title: "维修码",
      "min-width": "50"
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createVNode(_component_svg_icon, {
        iconName: "qr",
        iconSize: "18px",
        style: {
          "cursor": "pointer"
        },
        onClick: $event => _ctx.openQrcode(row)
      }, null, 8, ["onClick"])]),
      _: 1
    }), _ctx.permission.havePermission('报修', '预约') || _ctx.permission.havePermission('报修', '取消报修') || _ctx.permission.havePermission('报修', '报修指派') ? (_openBlock(), _createBlock(_component_vxe_column, {
      key: 0,
      title: "操作",
      "min-width": "170",
      fixed: "right"
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", _hoisted_38, _toDisplayString(column.title), 1)]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", _hoisted_39, [_ctx.permission.havePermission('报修', '报修指派') && row.repairResultId === 7 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: $event => _ctx.assignRepair(row),
        class: "sts-button default",
        style: {
          "height": "28px",
          "padding": "0",
          "width": "50px",
          "margin-right": "10px"
        }
      }, {
        default: _withCtx(() => [_hoisted_40]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true), _ctx.permission.havePermission('报修', '取消报修') && row.repairResultId === 7 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        onClick: $event => _ctx.cancelRepair(row),
        class: "sts-button default",
        style: {
          "height": "28px",
          "padding": "0",
          "width": "50px",
          "margin-right": "10px"
        }
      }, {
        default: _withCtx(() => [_hoisted_41]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true), _ctx.permission.havePermission('报修', '预约') && row.repairResultId === 1 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 2,
        onClick: $event => {
          _ctx.appointmentDialogVisible = true;
          _ctx.subscribeId = row.repairId;
        },
        class: "sts-button default",
        style: {
          "height": "28px",
          "padding": "0",
          "width": "50px"
        }
      }, {
        default: _withCtx(() => [_hoisted_42]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["data", "onHeaderCellClick", "onScroll", "row-class-name"])]), _createElementVNode("div", _hoisted_43, [_createVNode(_component_vxe_pager, {
    class: "sts-pager",
    background: "",
    "page-size": _ctx.paginationData.pageSize,
    "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => _ctx.paginationData.pageSize = $event),
    "current-page": _ctx.paginationData.currentPage,
    "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => _ctx.paginationData.currentPage = $event),
    "pager-count": 5,
    total: _ctx.paginationData.totalSize,
    "page-sizes": _ctx.paginationData.pageSizes,
    layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
    onPageChange: _ctx.paginationCurrentChange
  }, null, 8, ["page-size", "current-page", "total", "page-sizes", "onPageChange"])])])]), _createVNode(_component_a_modal, {
    open: _ctx.appointmentDialogVisible,
    "onUpdate:open": _cache[12] || (_cache[12] = $event => _ctx.appointmentDialogVisible = $event),
    closable: false,
    centered: true,
    modal: false,
    "close-on-click-modal": false,
    zIndex: 1001
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode("维修预约")]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _cache[11] || (_cache[11] = $event => _ctx.appointmentDialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.confirmSubscribe
    }, {
      default: _withCtx(() => [_createTextVNode("确定")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_a_form, {
      inline: true,
      model: _ctx.appointmentFormData,
      "show-message": false,
      "label-width": "0px",
      "label-col": {
        span: 5
      },
      labelAlign: 'left'
    }, {
      default: _withCtx(() => [_createVNode(_component_a_form_item, {
        label: "维修人："
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.appointmentFormData.repairPerson,
          "onUpdate:value": _cache[6] || (_cache[6] = $event => _ctx.appointmentFormData.repairPerson = $event),
          placeholder: "输入维修人",
          clearable: ""
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "对接人："
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.appointmentFormData.contactPerson,
          "onUpdate:value": _cache[7] || (_cache[7] = $event => _ctx.appointmentFormData.contactPerson = $event),
          placeholder: "输入对接人",
          clearable: ""
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "维修人联系方式："
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.appointmentFormData.repairPersonContact,
          "onUpdate:value": _cache[8] || (_cache[8] = $event => _ctx.appointmentFormData.repairPersonContact = $event),
          placeholder: "输入维修人联系方式",
          clearable: ""
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "对接人联系方式："
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.appointmentFormData.coordinatorContact,
          "onUpdate:value": _cache[9] || (_cache[9] = $event => _ctx.appointmentFormData.coordinatorContact = $event),
          placeholder: "输入对接人联系方式",
          clearable: ""
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "维修日期："
      }, {
        default: _withCtx(() => [_createVNode(_component_a_date_picker, {
          "show-time": "",
          editable: false,
          class: "light-gray-date-picker query-field",
          style: {
            "width": "200px"
          },
          value: _ctx.appointmentFormData.repairDate,
          "onUpdate:value": _cache[10] || (_cache[10] = $event => _ctx.appointmentFormData.repairDate = $event),
          placeholder: "请选择预约时间",
          format: "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          onChange: _ctx.queryRepair
        }, null, 8, ["value", "onChange"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])])]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.QRcodeVisible,
    "onUpdate:open": _cache[15] || (_cache[15] = $event => _ctx.QRcodeVisible = $event),
    centered: true,
    closable: false,
    zIndex: 1001,
    "align-center": "",
    modal: false,
    "append-to-body": "",
    "show-close": false,
    style: {
      "min-width": "400px",
      "max-width": "500px"
    }
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.QRcodeMsg.row.storeName), 1), _createElementVNode("div", _hoisted_54, [_createVNode(_component_svg_icon, {
      iconName: "copy",
      iconSize: "20px",
      onClick: _cache[13] || (_cache[13] = $event => _ctx.copyQrcode())
    })])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _cache[14] || (_cache[14] = $event => _ctx.QRcodeVisible = false),
      style: {
        "width": "100px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode("关闭")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, " 报修日期：" + _toDisplayString(_ctx.getDate(_ctx.QRcodeMsg.row.createTime - 60 * 60 * 1000 * 8)), 1), _createElementVNode("div", _hoisted_48, "供应商：" + _toDisplayString(_ctx.QRcodeMsg.row.vendorName), 1), _createElementVNode("div", _hoisted_49, [_createElementVNode("img", {
      src: _ctx.wxCodeImage,
      style: {
        "width": "150px",
        "height": "150px"
      }
    }, null, 8, _hoisted_50)]), _createElementVNode("div", _hoisted_51, " 起始日期：" + _toDisplayString(_ctx.getDate(_ctx.QRcodeMsg.row.createTime - 60 * 60 * 1000 * 8)), 1), _createElementVNode("div", _hoisted_52, " 截止日期：" + _toDisplayString(_ctx.getDate(_ctx.QRcodeMsg.row.createTime + 7 * 24 * 60 * 60 * 1000 - 60 * 60 * 1000 * 8)), 1)], 512)]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.photoVisible,
    "onUpdate:open": _cache[17] || (_cache[17] = $event => _ctx.photoVisible = $event),
    centered: true,
    style: {
      "min-width": "400px",
      "max-width": "500px"
    },
    "align-center": "",
    modal: false,
    zIndex: 1001,
    "append-to-body": ""
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode("查看")]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _cache[16] || (_cache[16] = $event => _ctx.photoVisible = false),
      style: {
        "width": "100px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode("关闭")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createVNode(_component_swiper, {
      modules: _ctx.modules,
      "slides-per-view": 1,
      "space-between": 50,
      pagination: {
        clickable: true
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photosView, (x, index) => {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          key: index
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: x.url,
            alt: "",
            style: {
              "width": "100%"
            }
          }, null, 8, _hoisted_57)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["modules"])])]),
    _: 1
  }, 8, ["open"]), _createVNode(_component_a_modal, {
    open: _ctx.assignOpenVisible,
    "onUpdate:open": _cache[24] || (_cache[24] = $event => _ctx.assignOpenVisible = $event),
    closable: false,
    zIndex: 1001,
    width: 600,
    centered: true
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_hoisted_60, _createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 20px",
        "min-width": "0px"
      }
    })])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _ctx.onAssignRepairCancel
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      loading: _ctx.loading,
      onClick: _ctx.onAssignRepairSave
    }, {
      default: _withCtx(() => [_createTextVNode("确定")]),
      _: 1
    }, 8, ["loading", "onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_a_form, {
      model: _ctx.assignRepairEditFormData,
      ref: "assignRepairEditForm",
      class: "sts-form",
      "label-col": {
        span: 8
      },
      "label-align": "left",
      autocomplete: "off"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_row, null, {
        default: _withCtx(() => [_createVNode(_component_a_col, null, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "报修门店:",
            name: "storeName",
            style: {
              "width": "450px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              disabled: true,
              value: _ctx.assignRepairEditFormData.storeName,
              "onUpdate:value": _cache[18] || (_cache[18] = $event => _ctx.assignRepairEditFormData.storeName = $event)
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "报修点位:",
            name: "locationName",
            style: {
              "width": "450px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              disabled: true,
              value: _ctx.assignRepairEditFormData.locationName,
              "onUpdate:value": _cache[19] || (_cache[19] = $event => _ctx.assignRepairEditFormData.locationName = $event)
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "供应商:",
            name: "repairerVendorId",
            rules: [{
              required: true,
              message: '请选择供应商'
            }],
            style: {
              "width": "450px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_tree_select, {
              value: _ctx.assignRepairEditFormData.repairerVendorId,
              "onUpdate:value": _cache[20] || (_cache[20] = $event => _ctx.assignRepairEditFormData.repairerVendorId = $event),
              treeData: _ctx.vendorTypeVendorData,
              treeDefaultExpandAll: true,
              defaultExpandAll: "",
              style: {
                "width": "300px"
              },
              onChange: _ctx.repairStoreLocationChange
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
                class: "ant-select-suffix"
              })]),
              _: 1
            }, 8, ["value", "treeData", "onChange"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "报修负责人:",
            name: "repairerLeadName",
            rules: [{
              required: true,
              message: '请输入报修负责人'
            }],
            style: {
              "width": "450px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_auto_complete, {
              value: _ctx.assignRepairEditFormData.repairerLeadName,
              "onUpdate:value": _cache[21] || (_cache[21] = $event => _ctx.assignRepairEditFormData.repairerLeadName = $event),
              options: _ctx.filterUserOption,
              "filter-option": false,
              onSelect: _ctx.selectUser,
              onSearch: _ctx.handleSearch
            }, null, 8, ["value", "options", "onSelect", "onSearch"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "联系方式:",
            name: "repairerLeadMobile",
            rules: [{
              required: true,
              message: '请输入联系方式'
            }],
            style: {
              "width": "450px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: _ctx.assignRepairEditFormData.repairerLeadMobile,
              "onUpdate:value": _cache[22] || (_cache[22] = $event => _ctx.assignRepairEditFormData.repairerLeadMobile = $event)
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "电子邮件:",
            name: "repairerLeadEmail",
            rules: [{
              required: true,
              message: '请输入电子邮件'
            }],
            style: {
              "width": "450px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: _ctx.assignRepairEditFormData.repairerLeadEmail,
              "onUpdate:value": _cache[23] || (_cache[23] = $event => _ctx.assignRepairEditFormData.repairerLeadEmail = $event)
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["open"])], 64);
}